/* tslint:disable */
/* eslint-disable */
/**
 * Mr.Bilit Authentication api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { AddStatusReportPenaltyRequest } from '../model';
// @ts-ignore
import { ChangeCreditResponse } from '../model';
// @ts-ignore
import { ChangeUserCreditRequest } from '../model';
// @ts-ignore
import { ChargeAndRefundTransactionResponse } from '../model';
// @ts-ignore
import { EditChangeCreditRequest } from '../model';
// @ts-ignore
import { MarkTransactionAsSuccessfulRequest } from '../model';
// @ts-ignore
import { UnsuccessfulUserTransactionViewPagedResponse } from '../model';
// @ts-ignore
import { UserTransactionViewPagedResponse } from '../model';
/**
 * UserTransactionApiApiUserAddStatusReportPenaltyPost - axios parameter creator
 * 
 * @summary  (Auth policies: auth:UserTransactions)
 * @param {AddStatusReportPenaltyRequest} [addStatusReportPenaltyRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserTransactionApiApiUserAddStatusReportPenaltyPostAxiosParamCreator (addStatusReportPenaltyRequest?: AddStatusReportPenaltyRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/user/AddStatusReportPenalty`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(addStatusReportPenaltyRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserTransactionApiApiUserCancelNonRefundableTransactionTransactionIdPost - axios parameter creator
 * 
 * @param {number} transactionId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserTransactionApiApiUserCancelNonRefundableTransactionTransactionIdPostAxiosParamCreator (transactionId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'transactionId' is not null or undefined
    assertParamExists('apiUserCancelNonRefundableTransactionTransactionIdPost', 'transactionId', transactionId)
    const localVarPath = `/api/user/CancelNonRefundableTransaction/{transactionId}`
        .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserTransactionApiApiUserCancelSuspendedTransactionTransactionIdPost - axios parameter creator
 * 
 * @summary  (Auth policies: auth:CancelUserTransaction)
 * @param {number} transactionId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserTransactionApiApiUserCancelSuspendedTransactionTransactionIdPostAxiosParamCreator (transactionId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'transactionId' is not null or undefined
    assertParamExists('apiUserCancelSuspendedTransactionTransactionIdPost', 'transactionId', transactionId)
    const localVarPath = `/api/user/CancelSuspendedTransaction/{transactionId}`
        .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserTransactionApiApiUserChangeCreditsGet - axios parameter creator
 * 
 * @summary  (Auth policies: auth:UserTransactions)
 * @param {number} userId 
 * @param {string} [fromStatusReportDate] 
 * @param {string} [toStatusReportDate] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserTransactionApiApiUserChangeCreditsGetAxiosParamCreator (userId: number, fromStatusReportDate?: string, toStatusReportDate?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'userId' is not null or undefined
    assertParamExists('apiUserChangeCreditsGet', 'userId', userId)
    const localVarPath = `/api/user/ChangeCredits`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (userId !== undefined) {
        localVarQueryParameter['userId'] = userId;
    }

    if (fromStatusReportDate !== undefined) {
        localVarQueryParameter['fromStatusReportDate'] = (fromStatusReportDate as any instanceof Date) ?
            (fromStatusReportDate as any).toISOString() :
            fromStatusReportDate;
    }

    if (toStatusReportDate !== undefined) {
        localVarQueryParameter['toStatusReportDate'] = (toStatusReportDate as any instanceof Date) ?
            (toStatusReportDate as any).toISOString() :
            toStatusReportDate;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserTransactionApiApiUserChargesAndRefundsUserIdGet - axios parameter creator
 * 
 * @summary  (Auth policies: auth:ChargeAndRefundsRepost)
 * @param {number} userId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserTransactionApiApiUserChargesAndRefundsUserIdGetAxiosParamCreator (userId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'userId' is not null or undefined
    assertParamExists('apiUserChargesAndRefundsUserIdGet', 'userId', userId)
    const localVarPath = `/api/user/ChargesAndRefunds/{userId}`
        .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserTransactionApiApiUserDeleteChangeCreditIdDelete - axios parameter creator
 * 
 * @summary  (Auth policies: auth:DeleteChangeUserCredit)
 * @param {number} id 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserTransactionApiApiUserDeleteChangeCreditIdDeleteAxiosParamCreator (id: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('apiUserDeleteChangeCreditIdDelete', 'id', id)
    const localVarPath = `/api/user/DeleteChangeCredit/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserTransactionApiApiUserEditChangeCreditIdPut - axios parameter creator
 * 
 * @summary  (Auth policies: auth:EditChangeUserCredit)
 * @param {number} id 
 * @param {EditChangeCreditRequest} [editChangeCreditRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserTransactionApiApiUserEditChangeCreditIdPutAxiosParamCreator (id: number, editChangeCreditRequest?: EditChangeCreditRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('apiUserEditChangeCreditIdPut', 'id', id)
    const localVarPath = `/api/user/EditChangeCredit/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(editChangeCreditRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserTransactionApiApiUserIdChangeCreditPost - axios parameter creator
 * 
 * @summary  (Auth policies: auth:ChangeUserCredit)
 * @param {number} id 
 * @param {ChangeUserCreditRequest} [changeUserCreditRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserTransactionApiApiUserIdChangeCreditPostAxiosParamCreator (id: number, changeUserCreditRequest?: ChangeUserCreditRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('apiUserIdChangeCreditPost', 'id', id)
    const localVarPath = `/api/user/{id}/change-credit`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(changeUserCreditRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserTransactionApiApiUserTransactionsGet - axios parameter creator
 * 
 * @summary getting a list of user\'s transaction with optional time filtering  operators need to fill in the userid (Auth)
 * @param {number} [userId] 
 * @param {string} [from] 
 * @param {string} [to] 
 * @param {number} [page] 
 * @param {number} [pageSize] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserTransactionApiApiUserTransactionsGetAxiosParamCreator (userId?: number, from?: string, to?: string, page?: number, pageSize?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/user/Transactions`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (userId !== undefined) {
        localVarQueryParameter['UserId'] = userId;
    }

    if (from !== undefined) {
        localVarQueryParameter['From'] = (from as any instanceof Date) ?
            (from as any).toISOString() :
            from;
    }

    if (to !== undefined) {
        localVarQueryParameter['To'] = (to as any instanceof Date) ?
            (to as any).toISOString() :
            to;
    }

    if (page !== undefined) {
        localVarQueryParameter['Page'] = page;
    }

    if (pageSize !== undefined) {
        localVarQueryParameter['PageSize'] = pageSize;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserTransactionApiApiUsersTransactionsTransactionIdPatch - axios parameter creator
 * 
 * @summary user unsuccessful transaction in a date range (Auth policies: Auth:UserTransactions)
 * @param {number} transactionId 
 * @param {MarkTransactionAsSuccessfulRequest} [markTransactionAsSuccessfulRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserTransactionApiApiUsersTransactionsTransactionIdPatchAxiosParamCreator (transactionId: number, markTransactionAsSuccessfulRequest?: MarkTransactionAsSuccessfulRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'transactionId' is not null or undefined
    assertParamExists('apiUsersTransactionsTransactionIdPatch', 'transactionId', transactionId)
    const localVarPath = `/api/users/transactions/{transactionId}`
        .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(markTransactionAsSuccessfulRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserTransactionApiApiUsersTransactionsUnsuccessfulGet - axios parameter creator
 * 
 * @summary user unsuccessful transaction in a date range (Auth policies: Auth:UserTransactions)
 * @param {number} [userId] 
 * @param {number} [paginationPage] 
 * @param {number} [paginationPageSize] 
 * @param {string} [dateRangeFrom] 
 * @param {string} [dateRangeTo] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserTransactionApiApiUsersTransactionsUnsuccessfulGetAxiosParamCreator (userId?: number, paginationPage?: number, paginationPageSize?: number, dateRangeFrom?: string, dateRangeTo?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/users/transactions/unsuccessful`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (userId !== undefined) {
        localVarQueryParameter['UserId'] = userId;
    }

    if (paginationPage !== undefined) {
        localVarQueryParameter['Pagination.Page'] = paginationPage;
    }

    if (paginationPageSize !== undefined) {
        localVarQueryParameter['Pagination.PageSize'] = paginationPageSize;
    }

    if (dateRangeFrom !== undefined) {
        localVarQueryParameter['DateRange.From'] = (dateRangeFrom as any instanceof Date) ?
            (dateRangeFrom as any).toISOString() :
            dateRangeFrom;
    }

    if (dateRangeTo !== undefined) {
        localVarQueryParameter['DateRange.To'] = (dateRangeTo as any instanceof Date) ?
            (dateRangeTo as any).toISOString() :
            dateRangeTo;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiUserAddStatusReportPenaltyPost operation in UserTransactionApi.
 * @export
 * @interface UserTransactionApiApiUserAddStatusReportPenaltyPostRequest
 */
export interface UserTransactionApiApiUserAddStatusReportPenaltyPostRequest {
    /**
     * 
     * @type {AddStatusReportPenaltyRequest}
     * @memberof UserTransactionApiApiUserAddStatusReportPenaltyPost
     */
    readonly addStatusReportPenaltyRequest?: AddStatusReportPenaltyRequest
}

/**
 * Request parameters for apiUserCancelNonRefundableTransactionTransactionIdPost operation in UserTransactionApi.
 * @export
 * @interface UserTransactionApiApiUserCancelNonRefundableTransactionTransactionIdPostRequest
 */
export interface UserTransactionApiApiUserCancelNonRefundableTransactionTransactionIdPostRequest {
    /**
     * 
     * @type {number}
     * @memberof UserTransactionApiApiUserCancelNonRefundableTransactionTransactionIdPost
     */
    readonly transactionId: number
}

/**
 * Request parameters for apiUserCancelSuspendedTransactionTransactionIdPost operation in UserTransactionApi.
 * @export
 * @interface UserTransactionApiApiUserCancelSuspendedTransactionTransactionIdPostRequest
 */
export interface UserTransactionApiApiUserCancelSuspendedTransactionTransactionIdPostRequest {
    /**
     * 
     * @type {number}
     * @memberof UserTransactionApiApiUserCancelSuspendedTransactionTransactionIdPost
     */
    readonly transactionId: number
}

/**
 * Request parameters for apiUserChangeCreditsGet operation in UserTransactionApi.
 * @export
 * @interface UserTransactionApiApiUserChangeCreditsGetRequest
 */
export interface UserTransactionApiApiUserChangeCreditsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof UserTransactionApiApiUserChangeCreditsGet
     */
    readonly userId: number

    /**
     * 
     * @type {string}
     * @memberof UserTransactionApiApiUserChangeCreditsGet
     */
    readonly fromStatusReportDate?: string

    /**
     * 
     * @type {string}
     * @memberof UserTransactionApiApiUserChangeCreditsGet
     */
    readonly toStatusReportDate?: string
}

/**
 * Request parameters for apiUserChargesAndRefundsUserIdGet operation in UserTransactionApi.
 * @export
 * @interface UserTransactionApiApiUserChargesAndRefundsUserIdGetRequest
 */
export interface UserTransactionApiApiUserChargesAndRefundsUserIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof UserTransactionApiApiUserChargesAndRefundsUserIdGet
     */
    readonly userId: number
}

/**
 * Request parameters for apiUserDeleteChangeCreditIdDelete operation in UserTransactionApi.
 * @export
 * @interface UserTransactionApiApiUserDeleteChangeCreditIdDeleteRequest
 */
export interface UserTransactionApiApiUserDeleteChangeCreditIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof UserTransactionApiApiUserDeleteChangeCreditIdDelete
     */
    readonly id: number
}

/**
 * Request parameters for apiUserEditChangeCreditIdPut operation in UserTransactionApi.
 * @export
 * @interface UserTransactionApiApiUserEditChangeCreditIdPutRequest
 */
export interface UserTransactionApiApiUserEditChangeCreditIdPutRequest {
    /**
     * 
     * @type {number}
     * @memberof UserTransactionApiApiUserEditChangeCreditIdPut
     */
    readonly id: number

    /**
     * 
     * @type {EditChangeCreditRequest}
     * @memberof UserTransactionApiApiUserEditChangeCreditIdPut
     */
    readonly editChangeCreditRequest?: EditChangeCreditRequest
}

/**
 * Request parameters for apiUserIdChangeCreditPost operation in UserTransactionApi.
 * @export
 * @interface UserTransactionApiApiUserIdChangeCreditPostRequest
 */
export interface UserTransactionApiApiUserIdChangeCreditPostRequest {
    /**
     * 
     * @type {number}
     * @memberof UserTransactionApiApiUserIdChangeCreditPost
     */
    readonly id: number

    /**
     * 
     * @type {ChangeUserCreditRequest}
     * @memberof UserTransactionApiApiUserIdChangeCreditPost
     */
    readonly changeUserCreditRequest?: ChangeUserCreditRequest
}

/**
 * Request parameters for apiUserTransactionsGet operation in UserTransactionApi.
 * @export
 * @interface UserTransactionApiApiUserTransactionsGetRequest
 */
export interface UserTransactionApiApiUserTransactionsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof UserTransactionApiApiUserTransactionsGet
     */
    readonly userId?: number

    /**
     * 
     * @type {string}
     * @memberof UserTransactionApiApiUserTransactionsGet
     */
    readonly from?: string

    /**
     * 
     * @type {string}
     * @memberof UserTransactionApiApiUserTransactionsGet
     */
    readonly to?: string

    /**
     * 
     * @type {number}
     * @memberof UserTransactionApiApiUserTransactionsGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof UserTransactionApiApiUserTransactionsGet
     */
    readonly pageSize?: number
}

/**
 * Request parameters for apiUsersTransactionsTransactionIdPatch operation in UserTransactionApi.
 * @export
 * @interface UserTransactionApiApiUsersTransactionsTransactionIdPatchRequest
 */
export interface UserTransactionApiApiUsersTransactionsTransactionIdPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof UserTransactionApiApiUsersTransactionsTransactionIdPatch
     */
    readonly transactionId: number

    /**
     * 
     * @type {MarkTransactionAsSuccessfulRequest}
     * @memberof UserTransactionApiApiUsersTransactionsTransactionIdPatch
     */
    readonly markTransactionAsSuccessfulRequest?: MarkTransactionAsSuccessfulRequest
}

/**
 * Request parameters for apiUsersTransactionsUnsuccessfulGet operation in UserTransactionApi.
 * @export
 * @interface UserTransactionApiApiUsersTransactionsUnsuccessfulGetRequest
 */
export interface UserTransactionApiApiUsersTransactionsUnsuccessfulGetRequest {
    /**
     * 
     * @type {number}
     * @memberof UserTransactionApiApiUsersTransactionsUnsuccessfulGet
     */
    readonly userId?: number

    /**
     * 
     * @type {number}
     * @memberof UserTransactionApiApiUsersTransactionsUnsuccessfulGet
     */
    readonly paginationPage?: number

    /**
     * 
     * @type {number}
     * @memberof UserTransactionApiApiUsersTransactionsUnsuccessfulGet
     */
    readonly paginationPageSize?: number

    /**
     * 
     * @type {string}
     * @memberof UserTransactionApiApiUsersTransactionsUnsuccessfulGet
     */
    readonly dateRangeFrom?: string

    /**
     * 
     * @type {string}
     * @memberof UserTransactionApiApiUsersTransactionsUnsuccessfulGet
     */
    readonly dateRangeTo?: string
}

/**
* 
* @summary  (Auth policies: auth:UserTransactions)
* @param {UserTransactionApiApiUserAddStatusReportPenaltyPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserTransactionApiApiUserAddStatusReportPenaltyPost(requestParameters: UserTransactionApiApiUserAddStatusReportPenaltyPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserTransactionApiApiUserAddStatusReportPenaltyPostAxiosParamCreator(requestParameters.addStatusReportPenaltyRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {UserTransactionApiApiUserCancelNonRefundableTransactionTransactionIdPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserTransactionApiApiUserCancelNonRefundableTransactionTransactionIdPost(requestParameters: UserTransactionApiApiUserCancelNonRefundableTransactionTransactionIdPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserTransactionApiApiUserCancelNonRefundableTransactionTransactionIdPostAxiosParamCreator(requestParameters.transactionId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary  (Auth policies: auth:CancelUserTransaction)
* @param {UserTransactionApiApiUserCancelSuspendedTransactionTransactionIdPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserTransactionApiApiUserCancelSuspendedTransactionTransactionIdPost(requestParameters: UserTransactionApiApiUserCancelSuspendedTransactionTransactionIdPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserTransactionApiApiUserCancelSuspendedTransactionTransactionIdPostAxiosParamCreator(requestParameters.transactionId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary  (Auth policies: auth:UserTransactions)
* @param {UserTransactionApiApiUserChangeCreditsGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserTransactionApiApiUserChangeCreditsGet(requestParameters: UserTransactionApiApiUserChangeCreditsGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserTransactionApiApiUserChangeCreditsGetAxiosParamCreator(requestParameters.userId, requestParameters.fromStatusReportDate, requestParameters.toStatusReportDate, options, configuration);
    const request: () => AxiosPromise<Array<ChangeCreditResponse>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary  (Auth policies: auth:ChargeAndRefundsRepost)
* @param {UserTransactionApiApiUserChargesAndRefundsUserIdGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserTransactionApiApiUserChargesAndRefundsUserIdGet(requestParameters: UserTransactionApiApiUserChargesAndRefundsUserIdGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserTransactionApiApiUserChargesAndRefundsUserIdGetAxiosParamCreator(requestParameters.userId, options, configuration);
    const request: () => AxiosPromise<Array<ChargeAndRefundTransactionResponse>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary  (Auth policies: auth:DeleteChangeUserCredit)
* @param {UserTransactionApiApiUserDeleteChangeCreditIdDeleteRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserTransactionApiApiUserDeleteChangeCreditIdDelete(requestParameters: UserTransactionApiApiUserDeleteChangeCreditIdDeleteRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserTransactionApiApiUserDeleteChangeCreditIdDeleteAxiosParamCreator(requestParameters.id, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary  (Auth policies: auth:EditChangeUserCredit)
* @param {UserTransactionApiApiUserEditChangeCreditIdPutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserTransactionApiApiUserEditChangeCreditIdPut(requestParameters: UserTransactionApiApiUserEditChangeCreditIdPutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserTransactionApiApiUserEditChangeCreditIdPutAxiosParamCreator(requestParameters.id, requestParameters.editChangeCreditRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary  (Auth policies: auth:ChangeUserCredit)
* @param {UserTransactionApiApiUserIdChangeCreditPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserTransactionApiApiUserIdChangeCreditPost(requestParameters: UserTransactionApiApiUserIdChangeCreditPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserTransactionApiApiUserIdChangeCreditPostAxiosParamCreator(requestParameters.id, requestParameters.changeUserCreditRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary getting a list of user\'s transaction with optional time filtering  operators need to fill in the userid (Auth)
* @param {UserTransactionApiApiUserTransactionsGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserTransactionApiApiUserTransactionsGet(requestParameters: UserTransactionApiApiUserTransactionsGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserTransactionApiApiUserTransactionsGetAxiosParamCreator(requestParameters.userId, requestParameters.from, requestParameters.to, requestParameters.page, requestParameters.pageSize, options, configuration);
    const request: () => AxiosPromise<UserTransactionViewPagedResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary user unsuccessful transaction in a date range (Auth policies: Auth:UserTransactions)
* @param {UserTransactionApiApiUsersTransactionsTransactionIdPatchRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserTransactionApiApiUsersTransactionsTransactionIdPatch(requestParameters: UserTransactionApiApiUsersTransactionsTransactionIdPatchRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserTransactionApiApiUsersTransactionsTransactionIdPatchAxiosParamCreator(requestParameters.transactionId, requestParameters.markTransactionAsSuccessfulRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary user unsuccessful transaction in a date range (Auth policies: Auth:UserTransactions)
* @param {UserTransactionApiApiUsersTransactionsUnsuccessfulGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserTransactionApiApiUsersTransactionsUnsuccessfulGet(requestParameters: UserTransactionApiApiUsersTransactionsUnsuccessfulGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserTransactionApiApiUsersTransactionsUnsuccessfulGetAxiosParamCreator(requestParameters.userId, requestParameters.paginationPage, requestParameters.paginationPageSize, requestParameters.dateRangeFrom, requestParameters.dateRangeTo, options, configuration);
    const request: () => AxiosPromise<UnsuccessfulUserTransactionViewPagedResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
